









import {
  computed, ComputedRef, defineComponent, Ref, ref,
} from '@vue/composition-api';
import { NumberIconProps } from './types';
import { useIconSizeObserver } from '../../hooks/useIconSizeObserver';

const DEFAULT_RATIO = 0.70;

interface NumberBinding {
  iconElement: Ref<HTMLDivElement | undefined>;
  iconCircleStyle: ComputedRef<CSSStyleDeclaration>;
}

export default defineComponent<NumberIconProps, NumberBinding>({
  name: 'NumberIcon',
  props: {
    value: {
      type: Number,
      required: true,
    },
    fontSizeRatio: {
      type: Number,
      default: DEFAULT_RATIO,
    },
  },
  setup(props) {
    const iconElement = ref<HTMLDivElement>();
    const iconSize = useIconSizeObserver(iconElement);

    return {
      iconElement,
      iconCircleStyle: computed<CSSStyleDeclaration>(() => ({
        height: `${iconSize.value}px`,
        fontSize: `${iconSize.value * (props.fontSizeRatio || DEFAULT_RATIO)}px`,
      } as CSSStyleDeclaration)),
    };
  },
});
